// Handles the lifecycle of a Bootstrap 4 modal, emits 'close' when the modal is closed
// When using a modal component with this mixin, put it in a v-if that is only
// true when the modal should be shown

export default {

    props: {
        escCloses: {
            type: Boolean,
            default: true
        }
    },

  mounted() {
    const $modal = $(this.$refs.modal);
    $modal.modal('show');

    // When modal is hidden (any reason), emit @close
    $modal.on('hidden.bs.modal', () => {
      this.$emit('close');
    });

    // Listen for Escape key globally
    if (this.escCloses){
        this._onEscKey = (e) => {
          if (e.key === 'Escape' || e.keyCode === 27) {
            this.hide();
          }
        };
        window.addEventListener('keyup', this._onEscKey);
    }
  },
  beforeDestroy() {
    const $modal = $(this.$refs.modal);

    // Move focus somewhere outside the modal
    if (document.activeElement && this.$refs.modal.contains(document.activeElement)) {
        document.activeElement.blur();
    }
    
    $modal.modal('hide');
    $modal.off('hidden.bs.modal');

    if (this._onEscKey){
        window.removeEventListener('keyup', this._onEscKey);
    }
  },
  methods: {
    hide() {
      $(this.$refs.modal).modal('hide');
    }
  }
};
